import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateAndDeleteFilters } from "store/filters/operations";
import { selectFilters } from "store/filters/selectors";
import { Checkbox, CustomPlaceholder } from "reusableComponents";
import { FiltersButton } from "..";
import { getUsageOptions } from "services/filters.services";
import { useTranslation } from "react-i18next";
import { useLanguage } from "context/languageContext";

import styles from "./styles.module.scss";

const UsagesFilter = ({ withStyledBtn = true }) => {
  const [t, i18n] = useTranslation("global");
  const dispatch = useDispatch();
  const filters = useSelector(selectFilters);
  const [showUsagesDropdown, setShowUsagesDropdown] = useState(false);
  const [usagesOptions, setUsagesOptions] = useState([]);
  const usagesDropdownRef = useRef(null);
  const { language } = useLanguage(); // Use the LanguageContext to get current language

  useEffect(() => {
    // Fetch usages options from API on mount
    const getUsagesOptions = async () => {
      const usages = await getUsageOptions(language);
      // Filter out the "Team Building" option
      // const filteredUsages = usages.filter(
      //   (usage) => usage.key !== "teambuilding"
      // );
      const filteredUsages = usages;
      // setUsagesOptions(filteredUsages);
      setUsagesOptions([
        ...filteredUsages,
        { id: "all", key: "all", name: t("search.allUsages") },
      ]);
    };
    getUsagesOptions();

    // Handle outside click to close the dropdown
    const handleClickOutside = (event) => {
      if (
        usagesDropdownRef.current &&
        !usagesDropdownRef.current.contains(event.target)
      ) {
        setShowUsagesDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleShowUsagesDropdown = () => {
    setShowUsagesDropdown((prevState) => !prevState);
  };

  const handleUsageChange = (option) => {
    // Set the selected usage option directly
    if (option.key === "all") {
      // If "All" is selected, deselect all other filters
      dispatch(
        updateAndDeleteFilters({ usages: [] }, [
          "price_type",
          "capacity",
          "min_price",
          "max_price",
          "options",
        ])
      );
    } else {
      const newUsage = option.key === filters.usages?.[0] ? null : option.key;

      dispatch(
        updateAndDeleteFilters(
          {
            usages: newUsage ? [newUsage] : [],
          },
          ["price_type", "capacity", "min_price", "max_price", "options"]
        )
      );
    }
    setShowUsagesDropdown(false); // Close dropdown after selection
  };

  // Get the name of the selected usage option for the placeholder
  const selectedUsage = usagesOptions.find(
    (usage) => usage.key === filters.usages?.[0]
  );

  return (
    <div className={styles.usagesWrapper} ref={usagesDropdownRef}>
      {withStyledBtn ? (
        <FiltersButton
          label={selectedUsage ? selectedUsage.name : t("search.defaultUsage")}
          isActive={!!filters.usages?.length}
          onClick={toggleShowUsagesDropdown}
        />
      ) : (
        <CustomPlaceholder
          condition={filters.usages?.length > 0} // Ensure usages is not empty
          text={selectedUsage ? selectedUsage.name : t("search.defaultUsage")} // Use selected usage name or default text
          defaultText={t("search.defaultUsage")}
          onClick={toggleShowUsagesDropdown}
        />
      )}
      <div
        className={`${styles.usagesDropdownBody} ${
          showUsagesDropdown ? styles.visible : styles.hidden
        }`}
      >
        {usagesOptions.map((usage) => (
          <div key={usage.id} className={styles.usageOption}>
            <Checkbox
              // checked={filters.usages?.includes(usage.key)}
              checked={
                usage.key === "all"
                  ? filters.usages?.length === 0
                  : filters.usages?.includes(usage.key)
              } // **Fixed checked logic**
              onChange={() => handleUsageChange(usage)}
              label={usage.name}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default UsagesFilter;
